import { t } from "i18next";
import { observer } from "mobx-react-lite";
import React from "react";
import { composeLabelsWithEditConfig } from "src/common/attributes/makeAttrLabel/utils/composeLabelWithConf";
import { classNames } from "src/common/classNames";
import { ColumnPoor } from "src/components/tables/ColumnPoor";
import { getColumnWidthStyles } from "../../../pages/EntityFiltersPage/AsyncTableView/templates/getColumnWidths";
import { ChildEntitiesStore } from "../ChildEntitiesStore";
import styles from "./SummaryFooter.module.less";

interface PropsSummaryFooter {
  store: ChildEntitiesStore;
}

export const SummaryFooter: React.FC<PropsSummaryFooter> = observer(
  ({ store }) => {
    const { tableStore, summaryAttrs, summaryValues, attrsMap, typesMap } =
      store;
    if (!tableStore || tableStore?.rows.length === 0) return null;

    const renderLabel = (column: ColumnPoor): React.ReactNode => {
      const value = summaryValues?.[column.key];
      const attribute = attrsMap[column.key];
      if (!(summaryAttrs?.includes(column.key) && attribute && value)) {
        return null;
      }
      return composeLabelsWithEditConfig(attribute, [String(value)], typesMap);
    };

    return (
      <div className={styles.tableFooter}>
        <div
          className={classNames([styles.footerItem, styles.footerItemTitle])}
        >
          {t("Total")}
        </div>
        {tableStore.finalColumns.map((column) => (
          <div
            className={styles.footerItem}
            key={column.key}
            style={getColumnWidthStyles(tableStore.columnWidths, column.key)}
          >
            <div className={styles.columnFooterContent}>
              {renderLabel(column)}
            </div>
          </div>
        ))}
      </div>
    );
  },
);
